import { useTranslation } from 'react-i18next'
import { useApp } from '../../context/AppContext'

export default function SummarySection() {
  const { t } = useTranslation()
  const { removedLines, removedWords } = useApp()

  return (
    <section className="mb-16">
      <div className="text-center mb-8">
        <h3 className="text-3xl font-black uppercase tracking-tighter">
          {t('summary.title')}
        </h3>
        <div className="h-1.5 w-24 bg-neonGreen mx-auto mt-2 rounded-full shadow-[0_0_10px_rgba(69,255,34,0.5)]" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Lines removed */}
        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-brand to-neonBlue rounded-twelve blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200" />
          <div className="relative bg-cardBg border-2 border-brand/50 p-10 rounded-twelve flex flex-col items-center justify-center overflow-hidden transition-all duration-300 transform group-hover:-translate-y-1">
            <span className="text-7xl md:text-8xl font-black mb-2 block bg-gradient-to-br from-white to-neonBlue bg-clip-text text-transparent drop-shadow-[0_0_10px_rgba(0,234,255,0.5)] glitch-hover cursor-default">
              {removedLines}
            </span>
            <span className="text-neonBlue font-black uppercase tracking-[0.2em] text-xs md:text-sm text-center">
              {t('summary.linesDeleted')}
            </span>
            <div className="mt-4 px-3 py-1 bg-brand/20 rounded-full border border-brand/30 text-[10px] font-black text-slate-900 dark:text-white uppercase tracking-widest">
              {t('summary.rankRookie')}
            </div>
          </div>
        </div>

        {/* Words removed */}
        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-neonPink to-purple-600 rounded-twelve blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200" />
          <div className="relative bg-cardBg border-2 border-neonPink/50 p-10 rounded-twelve flex flex-col items-center justify-center overflow-hidden transition-all duration-300 transform group-hover:-translate-y-1">
            <span className="text-7xl md:text-8xl font-black mb-2 block bg-gradient-to-br from-white to-neonPink bg-clip-text text-transparent drop-shadow-[0_0_10px_rgba(255,61,240,0.5)] glitch-hover cursor-default">
              {removedWords}
            </span>
            <span className="text-neonPink font-black uppercase tracking-[0.2em] text-xs md:text-sm text-center">
              {t('summary.wordsNuked')}
            </span>
            <div className="mt-4 px-3 py-1 bg-neonPink/20 rounded-full border border-neonPink/30 text-[10px] font-black text-slate-900 dark:text-white uppercase tracking-widest">
              {t('summary.statusInit')}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
